
import React, { useState } from 'react';
// import { useSelector } from 'react-redux';

import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import '../../../../assets/style/styleModalList.css'
import { Link } from 'react-router-dom';

export const DialogFormEditTemplates = ({ open, setOpen, templateInfo, handleSaveChange }) => {
    const [taskList, setTaskList] = useState(JSON.parse(templateInfo?.detalle_plantilla))

    const handleDelete = async (item, type, hitoId = null) => {

        let newList = []
        if (type === 'hito') {
            newList = taskList?.filter(hito => hito.id !== item.id)
        }

        if (type === 'task') {
            newList = taskList.map(hito => {
                if (hito.id === item.id_hito) {
                    return {
                        ...hito,
                        subs: hito.subs?.filter(task => task.id !== item.id)
                    }
                }

                return hito
            })
        }

        if (type === 'subtask') {
            newList = taskList.map(hito => {
                if (hito.id === hitoId) {
                    return {
                        ...hito,
                        subs: hito.subs?.map(task => {
                            if (task.id === item.id_tarea) {
                                return {
                                    ...task,
                                    subs: task.subs?.filter(subtask => subtask.id !== item.id)
                                }
                            }

                            return task

                        })
                    }
                }

                return hito
            })
        }

        setTaskList(newList)
    }

    return (
        <Dialog
            className='dialogModalList'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>

                <h1 className='TitleModalPresupuesto'>
                    <span className='' style={{ fontSize: '16px' }}>Plantilla {templateInfo?.nombre}</span>
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                {(templateInfo?.detalle_plantilla !== JSON.stringify(taskList)) ?
                    <div className='m-2'>
                        <button
                            style={{ width: '200px' }}
                            className='btn p-btn-primary'
                            onClick={() => handleSaveChange(taskList)}
                        >
                            <i className="bi bi-plus"></i> Guardar cambios
                        </button>
                    </div> : ''
                }

                <div style={{ width: '700px' }}>
                    {taskList?.map(hito => (
                        <div key={hito.id} className='p-1'>
                            <div
                                className='d-flex justify-content-between p-1'
                                style={{ border: '1px solid lightgray', backgroundColor: 'lightgray' }}
                            >
                                <div style={{ fontSize: '16px' }}>({hito.orden}) Hito: {hito.nombre}</div>
                                <div>
                                    {/* <Link to="">
                                        <i
                                            className="bi bi-pencil"
                                            style={{ fontSize: '12px', color: 'black' }}>
                                        </i>
                                    </Link> */}
                                    <Link to="" className='ms-2 me-2' onClick={() => handleDelete(hito, 'hito', null)}>
                                        <i
                                            className="bi bi-x-circle"
                                            style={{ fontSize: '13px', color: 'black' }}>
                                        </i>
                                    </Link>
                                </div>
                            </div>

                            {hito?.subs.map(task => (
                                <div key={task.id} className=''>
                                    <div className='d-flex justify-content-between p-1' style={{ border: '1px solid lightgray' }}>
                                        <div className='ms-1' style={{ fontSize: '14px' }}>({task.orden}) Tarea: {task.nombre}</div>
                                        <div>
                                            {/* <Link to="">
                                                <i
                                                    className="bi bi-pencil"
                                                    style={{ fontSize: '12px', color: 'black' }}>
                                                </i>
                                            </Link> */}
                                            <Link to="" className='ms-2 me-2' onClick={() => handleDelete(task, 'task', null)}>
                                                <i
                                                    className="bi bi-x-circle"
                                                    style={{ fontSize: '13px', color: 'black' }}>
                                                </i>
                                            </Link>
                                        </div>
                                    </div>
                                    {task?.subs.map(subtask => (
                                        <div key={subtask.id}>
                                            <div className='d-flex justify-content-between p-1' style={{ border: '1px solid lightgray' }}>
                                                <div className='ms-4' style={{ fontSize: '13px' }}>({subtask.orden}) Subtarea: {subtask.nombre}</div>
                                                <div>
                                                    {/* <Link to="">
                                                        <i
                                                            className="bi bi-pencil"
                                                            style={{ fontSize: '12px', color: 'black' }}>
                                                        </i>
                                                    </Link> */}
                                                    <Link to="" className='ms-2 me-2' onClick={() => handleDelete(subtask, 'subtask', hito.id)}>
                                                        <i
                                                            className="bi bi-x-circle"
                                                            style={{ fontSize: '13px', color: 'black' }}>
                                                        </i>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

            </div>
        </Dialog>
    )
}
